import { FC, ReactNode } from 'react'
import { useNavigate } from 'react-router-dom'
import { cn } from 'src/utils/cn'
import styles from './pageBackLink.module.scss'

interface PageBackLinkProps {
  className?: string
  // The parent section, e.g. "Social Listening". The page's own name goes in
  // the heading under it, so every module reads the same way:
  //   ← Social Listening
  //   Campaigns
  label: string
  // Overrides navigation; otherwise `to`, otherwise back in history.
  onClick?: () => void
  to?: string
}

export const PageBackLink: FC<PageBackLinkProps> = ({
  className,
  label,
  onClick,
  to,
}) => {
  const navigate = useNavigate()
  const handleClick = () => {
    if (onClick) onClick()
    else if (to) navigate(to)
    else navigate(-1)
  }

  return (
    <button
      className={cn(styles.backLink, className)}
      onClick={handleClick}
      type="button"
    >
      <svg aria-hidden fill="none" height="16" viewBox="0 0 16 16" width="16">
        <path
          d="M13 8H3M3 8L7.5 3.5M3 8L7.5 12.5"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
      </svg>
      <span>{label}</span>
    </button>
  )
}

// The 24px page name that sits under PageBackLink.
export const PageTitle: FC<{ children: ReactNode; className?: string }> = ({
  children,
  className,
}) => <h1 className={cn(styles.title, className)}>{children}</h1>
